<script setup lang="ts">
import { computed } from 'vue';

type Type = 'main';
type Icon = 'heart' | 'trash' | 'ruler' | 'info' | 'tools' | 'plus' | 'phone' | 'settings' | 'close' | 'chevron' | 'search';

const props = defineProps<{
  type: Type
  icon: Icon
  width: number
  height: number
}>();
const spritePath = computed(() => `/sprites/${props.type}.svg#${props.icon}`);
</script>

<template>
  <svg :width="width" :height="height">
    <use :xlink:href="spritePath" />
  </svg>
</template>

<style scoped lang="scss">

</style>
